import axios from "axios";
import { Modal } from "antd";

export const baseURL = process.env.REACT_APP_API_URL;

// export const socket = new SockJS(baseURL + 'ws-notification');

// Create an axios instance with default config and hardcoded token
const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
    // Authorization: 'eyJhbGciOiJIUzUxMiJ9.eyJpZFVzZXIiOjI0LCJzdWIiOiIxZmQ0MDMyOS04ODY5LTQzY2YtYjkxNy1mYTBkOTZlY2I2NzIiLCJpZFVzZXJMZXZlbCI6MSwibmFtZSI6IlVzZXIgQWRtaW4iLCJleHAiOjE3MjU5MjIyMzAsImlhdCI6MTcyNTg4NjIzMCwiZW1haWwiOiJhZG1pbkBnbWFpbC5jb20iLCJ1c2VybmFtZSI6ImFkbWluIiwic3RhdHVzIjoxfQ.LzpcRwZqseZATTXcYuVs60bcTTgIIneVb-iJ1iVaVHlFpC2ow416v8MU0gqY4xDcU-LQWA9oqh0zR1O-SIJZjw', // Hardcoded token
    "Access-Control-Allow-Origin": "*",
    // "sub": "1fd40329-8869-43cf-b917-fa0d96ecb672",
  },
});

// axiosInstance.interceptors.request.use((config) => {
//   const token = TokenService.getLocalAccessToken();
//   if (token) {
//     config.headers['Authorization'] = token;
//   }
//   return config;
// });

// Track location
let currentGeo = { lat: null, long: null };

if (navigator.geolocation) {
  navigator.geolocation.watchPosition(
    (position) => {
      currentGeo = {
        lat: position.coords.latitude,
        long: position.coords.longitude,
      };
    },
    (err) => console.warn("Geolocation warning:", err.message),
    { enableHighAccuracy: true, maximumAge: 10000, timeout: 10000 },
  );
}

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Inject current location if available
  if (currentGeo.lat && currentGeo.long) {
    config.headers["x-latitude"] = currentGeo.lat;
    config.headers["x-longitude"] = currentGeo.long;
  }

  return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip redirect if request has skipRedirect flag
    if (originalRequest.skipRedirect) {
      return Promise.reject(error);
    }

    // Catch 401 or 403 (Token Expired/Invalid)
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/auth/login")
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token");
        }

        // Try silent refresh
        const res = await axios.post(`${baseURL}/auth/refresh-token`, {
          refreshToken,
        });

        if (res.data.success) {
          const newToken = res.data.token;
          localStorage.setItem("token", newToken);

          // Update header
          axiosInstance.defaults.headers.common["Authorization"] =
            `Bearer ${newToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;

          processQueue(null, newToken);
          return axiosInstance(originalRequest);
        } else {
          throw new Error("Refresh failed");
        }
      } catch (err) {
        processQueue(err, null);
        console.error("Silent refresh failed", err);
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
